import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

import useConfigs from "../../hooks/useConfigs";
import useThemes from "../../hooks/useThemes";

const TextInputContainer = styled.div`
  margin-bottom: 1rem;
  width: ${(props) => props.width};

  h4 {
    color: ${(props) => props.color};
    font-weight: 700;
    text-transform: uppercase;
    font-size: ${(props) => 15 * props.fontsizemultiplier} !important;
  }

  input {
    width: 100%;
    padding: 1rem;
    border-radius: 2rem;
    background-color: ${(props) => props.backgroundinput};
    border: 1px solid
      ${(props) => (props.error ? "#ff7777" : props.bordercolor)};
    font-size: ${(props) => 15 * props.fontsizemultiplier} !important;
    color: ${(props) => props.colorinput};

    &:focus {
      border: 2px solid ${(props) => props.bordercolor};
      outline: none;
    }
  }

  p {
    font-size: ${(props) => 15 * props.fontsizemultiplier} !important;
    margin-top: 0.5rem;
    color: #ff7777;
  }

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

const CustomInput = ({
  label,
  width,
  error,
  value,
  onChange,
  onBlur,
  type,
  placeholder,
}) => {
  const { fontSizeMultiplier } = useConfigs();
  const { colorPrincipal, colorCuarto, colorSexto, backgroundDecimo } =
    useThemes();

  return (
    <TextInputContainer
      width={width}
      fontsizemultiplier={fontSizeMultiplier}
      color={colorPrincipal}
      bordercolor={colorSexto}
      backgroundinput={backgroundDecimo}
      colorinput={colorCuarto}
      error={error}
    >
      <h4>{label}</h4>
      <input
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
      />
      <p>{error?.message}</p>
    </TextInputContainer>
  );
};

export default CustomInput;

CustomInput.propTypes = {
  label: PropTypes.string,
  width: PropTypes.string,
  error: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  type: PropTypes.string,
  placeholder: PropTypes.string,
};

CustomInput.defaultProps = {
  width: "100%",
  type: "text",
};
